<template>
  <div>
    <div class="card-header">
      <div class="card-header-title">
        {{ titulo }}
      </div>
      <div class="card-header-text">
        <div>
          <strong> {{ texto1 }} </strong>
        </div>
        <div class="card-header-text-2">
          {{ texto2 }}
        </div>                
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    titulo: String,
    texto1: String,
    texto2: String,
    texto3: String,
  },
};
</script>

<style scoped>  
.card-header {
  width: 100%;
  /* height: 225px; */
  display: block;
  text-align: center;
  background-color: #f3f3f3;
}

.card-header-title {  
  color: #00945e;
  font-size: 35px;
  font-family: UnimedSlab-SemiBold;
  width: auto;
  margin: auto;
  padding-top: 40px;
  padding-bottom: 15px;
  border-bottom: 1px solid #dcdfe2;
}

.card-header-text {
  font-size: 14px;
  font-family: UnimedSans-SemiBold;
  padding-top: 15px;
}

.card-header-text-2 {
  font-family: UnimedSans-Regular;
}

@media (min-width:320px){
  .card-header {
    height: 280px;
  }
}
@media (min-width: 480px) {
  .card-header {
    height: 225px;
  }
}
</style>